import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'gold';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  children: React.ReactNode;
  className?: string;
  icon?: boolean;
  'aria-label'?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  href,
  children,
  className = '',
  icon = false,
  'aria-label': ariaLabel,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-brand-blue text-white border border-brand-yellow hover:bg-[#3d6fa3] hover:border-brand-yellow focus:ring-brand-blue',
    secondary: 'bg-transparent border-2 border-brand-blue text-brand-blue hover:bg-brand-blue/10 focus:ring-brand-blue',
    ghost: 'bg-transparent text-navy-700 hover:bg-navy-100 hover:text-navy-900 focus:ring-navy-200',
    gold: 'bg-brand-yellow text-navy-900 hover:bg-gold-500 hover:text-navy-900 focus:ring-brand-yellow'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-7 py-3 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const content = <>
      {children}
      {icon && <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-39" />}
    </>;
  if (href) {
    if (href.startsWith('http') || href.startsWith('#') || href.startsWith('mailto:')) {
      const isExternal = href.startsWith('http');
      return <a href={href} className={classes} data-component="COMP-03-Button" aria-label={ariaLabel} {...isExternal ? {
        rel: 'noopener noreferrer'
      } : {}} data-id="element-40">
          {content}
        </a>;
    }
    return <Link to={href} className={classes} data-component="COMP-03-Button" aria-label={ariaLabel} data-id="element-41">
        {content}
      </Link>;
  }
  return <button className={classes} data-component="COMP-03-Button" aria-label={ariaLabel} {...props} data-id="element-42">
      {content}
    </button>;
}